import styled from "@emotion/styled";

export const Container = styled.div`
  grid-area: industry-list;

  display: flex;
  gap: 28px;
  justify-content: flex-start;
`;

export const Separator = styled.div`
  block-size: 80px;

  border-inline-start: 1px solid #000000;
`;
